import Cookies from "universal-cookie";

const initState = {
  user: {
    isLoggedIn: false,
  },
};

const cookie = new Cookies();

const userCookieConfigs = {
  path: "/",
  sameSite: "strict",
  // 3 days in seconds
  // maxAge: 259200, // default: 3 days
};

const getCookieConfigs = (user) =>
  user.rememberMe
    ? { ...userCookieConfigs, maxAge: user.expires_in || 259200 }
    : userCookieConfigs;

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN": {
      const user = { ...action.user, isLoggedIn: true };

      cookie.set("user", user, getCookieConfigs(action.user));

      return {
        ...state,
        user,
      };
    }
    case "UPDATE": {
      const user = { ...state.user, ...action.user };

      cookie.set("user", user, getCookieConfigs(user));

      return {
        ...state,
        user,
      };
    }
    case "LOGOUT": {
      cookie.remove("user", getCookieConfigs(state.user));

      // Clear all project and location related localStorage items
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key.startsWith("project-") ||
          key.startsWith("selected-forms-location-root") ||
          key.startsWith("selected-location-sets")
        ) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));

      return {
        ...state,
        user: {
          isLoggedIn: false,
        },
      };
    }
    default:
      return state;
  }
};

export default authReducer;
